import { Colors } from "../../utils/colors";
import ConfirmActionModal from "../Containers/ConfirmPopups/ConfirmActionModal";
import {
  MARKIT_PRIVACY_POLICY,
  MARKIT_TERMS_OF_USE,
} from "@markit/common.utils";
import PhoneComplianceTerms from "./PhoneComplianceTerms";

type RemoveComplianceConfirmModalProps = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  confirmOnPress: () => Promise<void> | void;
};

// Confirms a creator wants to remove the compliance disclosure from the Instagram
// DM Automation phone-number prompt (Terms of Use section 2.7).
const RemoveComplianceConfirmModal = (
  props: RemoveComplianceConfirmModalProps
) => {
  const { isVisible, setIsVisible, confirmOnPress } = props;

  return (
    <ConfirmActionModal
      heading="Are you sure you want to remove opt-in compliance language?"
      subtext={
        <div className="ColumnNormal" style={{ gap: 10, paddingTop: 10 }}>
          <span className="smallBodySubtext">
            The following is appended by default to the end of the DM sent to
            prompt the user for their phone number:
          </span>
          <div
            className="ColumnNormal"
            style={{
              backgroundColor: Colors.WHITE1,
              border: `0.5px solid ${Colors.GRAY2}`,
              borderRadius: 8,
              padding: 10,
              whiteSpace: "pre-wrap",
              color: Colors.BLACK,
            }}
          >
            <PhoneComplianceTerms />
          </div>
          <span className="smallBodySubtext">
            By agreeing to remove the compliance language, you acknowledge and
            agree to take full responsibility of liabilities and you have
            reviewed our{" "}
            <a
              href={MARKIT_TERMS_OF_USE}
              target="_blank"
              rel="noreferrer"
              style={{ textDecorationLine: "underline", color: Colors.BLACK }}
            >
              Terms of Use
            </a>{" "}
            and{" "}
            <a
              href={MARKIT_PRIVACY_POLICY}
              target="_blank"
              rel="noreferrer"
              style={{ textDecorationLine: "underline", color: Colors.BLACK }}
            >
              Privacy Policy
            </a>{" "}
            again, paying close attention to Terms of Use Section 2.7 Instagram
            DM Automation Compliance Disclosure.
          </span>
        </div>
      }
      confirmButtonText="I Agree"
      hideModal={!isVisible}
      setIsVisible={setIsVisible}
      confirmOnPress={confirmOnPress}
    />
  );
};

export default RemoveComplianceConfirmModal;
